"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyFooter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const styled_components_1 = __importDefault(require("styled-components"));
const PrimaryButton_1 = require("../../atoms/PrimaryButton/PrimaryButton");
const SecondaryButton_1 = require("../../atoms/SecondaryButton/SecondaryButton");
function StickyFooter({ dualBtn, isShowTable, isActiveTrial, isMobile, isLandscape, t, handleTrialClick, handleBuyClick, }) {
    const primaryButtonLabel = isShowTable
        ? t(i18n_1.Strings.userOnboarding.subsSheet.buyButton)
        : t(i18n_1.Strings.userOnboarding.subsSheet.buy.confirmButton);
    const secondaryButtonLabel = t(i18n_1.Strings.userOnboarding.subsSheet[isActiveTrial ? 'trialButton' : 'tryButton']);
    return ((0, jsx_runtime_1.jsx)(Container, { isMobile: isMobile, isLandscape: isLandscape, "data-e2e": 'StickyFooter_Container', children: (0, jsx_runtime_1.jsxs)(ButtonsContainer, { isMobile: isMobile, isLandscape: isLandscape, "data-e2e": 'StickyFooter_ButtonsContainer', children: [dualBtn && ((0, jsx_runtime_1.jsx)(StyledSecondaryButton, { tabIndex: 0, onClick: handleTrialClick, "data-e2e": 'StickyFooter_StyledSecondaryButton', children: secondaryButtonLabel })), (0, jsx_runtime_1.jsx)(StyledPrimaryButton, { tabIndex: 0, onClick: handleBuyClick, "data-e2e": 'StickyFooter_StyledPrimaryButton', children: primaryButtonLabel })] }) }));
}
exports.StickyFooter = StickyFooter;
exports.default = StickyFooter;
const Container = styled_components_1.default.div `
  z-index: 20;

  display: flex;
  height: 128px;
  border-top: 2px solid #47cfcb;
  background-color: #11151c;

  ${({ isMobile, isLandscape }) => isMobile && !isLandscape && `height: 206px;`};
`;
const ButtonsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${({ isMobile, isLandscape }) => isMobile && !isLandscape && `flex-direction: column;`};
`;
const StyledPrimaryButton = (0, styled_components_1.default)(PrimaryButton_1.PrimaryButton) `
  text-transform: uppercase;
  width: 100%;
  max-width: 300px;
  margin: 0.5em;
`;
const StyledSecondaryButton = (0, styled_components_1.default)(SecondaryButton_1.SecondaryButton) `
  text-transform: uppercase;
  width: 100%;
  max-width: 300px;
  margin: 0.5em;
`;
